import { axios } from '@/utils/request'
// 查询区域列表
export function getAreaList(params) {
  return axios({
    url: '/regions',
    method: 'get',
    params: params
  })
}

// 添加区域/修改区域
export function updateArea(params) {
  return axios({
    url: '/region/save',
    method: 'post',
    data: params
  })
}

// 删除区域
export function deleteArea(area_id) {
  return axios({
    url: `/region/${area_id}`,
    method: 'delete'
  })
}